import configureStore from 'configureStore';
import { ConnectedRouter } from 'connected-react-router';
import App from 'containers/App';
import ErrorBoundry from 'containers/ErrorBoundary';
import LanguageProvider from 'containers/LanguageProvider';
import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as serviceWorker from 'serviceWorker';
import history from 'utils/history';
import '../src/styles/main.scss';
import { translationMessages } from './i18n';

const initialState = {};
export const store = configureStore(initialState, history);

const MOUNT_NODE = document.getElementById('root');

if (
  process.env.REACT_APP_BUGSNAG_API_KEY &&
  process.env.REACT_APP_BUGSNAG_ENABLED
) {
  Bugsnag.start({
    apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact()],
    // enabledReleaseStages: ['production'],
    // releaseStage: process.env.NODE_ENV,
  });
}

const render = (messages) => {
  ReactDOM.render(
    <Provider store={store}>
      <LanguageProvider messages={messages}>
        <ConnectedRouter history={history}>
          <ErrorBoundry>
            <App />
          </ErrorBoundry>
        </ConnectedRouter>
      </LanguageProvider>
    </Provider>,
    MOUNT_NODE
  );
};

if (module.hot) {
  module.hot.accept(['./i18n', 'containers/App'], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    render(translationMessages);
  });
}

if (!window.Intl) {
  new Promise((resolve) => {
    resolve(import('intl'));
  })
    .then(() => Promise.all([import('intl/locale-data/jsonp/en.js')]))
    .then(() => render(translationMessages))
    .catch((err) => {
      throw err;
    });
} else {
  render(translationMessages);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
